import { DONT_NEED, FILED_EXTERNALLY } from "./cartItemDeletionReasons";

export const CART_ITEM_DELETION_REASON_DICT = {
  [DONT_NEED]: "I don't need this filing",
  [FILED_EXTERNALLY]: "I filed it externally",
};
